// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cancel: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M21,0.17C9.48,0.17,0.17,9.48,0.17,21c0,11.52,9.31,20.83,20.83,20.83
	c11.52,0,20.83-9.31,20.83-20.83C41.83,9.48,32.52,0.17,21,0.17z M31.42,28.48l-2.94,2.94L21,23.94l-7.48,7.48l-2.94-2.94L18.06,21
	l-7.48-7.48l2.94-2.94L21,18.06l7.48-7.48l2.94,2.94L23.94,21L31.42,28.48z"/>
</svg>;
};

export default React.memo(Cancel);
